import { Link } from 'react-router-dom';
import { FaArrowRight } from "react-icons/fa6";
import { HiOutlineBookOpen } from "react-icons/hi";

const programCard = () => {
    return (
        <section className='mb-5 md:mt-14 mijsc-programs md:p-5 p-5'>
            <div className='my-5'>
                <h2 className='text-4xl font-bold'>MIJSC Programs</h2>
                <p className='pb-5 mb-5 mt-2'>Comprehensive programs designed to bridge industry and academia</p>
            </div>



            <div className='md:max-0 w-full h-fit md:flex  place-content-center mb-2 gap-7'>
                <Link to="/faculty-development-program">
                    <div className="py-5">
                        <div
                            className="relative rounded-t-xl md:w-[25rem] h-[180px] bg-cover bg-center transition-all duration-700"
                            style={{
                                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/lmp-faculty-development-program.jpg)`
                            }}>
                            <div className="hidden md:flex absolute top-3 left-3 z-20">
                                <div className="gap-3 w-fit h-fit rounded-xl shadow-2xl  flex items-center justify-center">
                                    <HiOutlineBookOpen className="text-white border-white  border bg-transparent w-fit h-[40px] p-1 rounded-md" />
                                </div>
                            </div>
                        </div>
                        <div className="shadow-xl md:w-[25rem] h-fit pb-5 rounded-b-lg px-4 text-left bg-white">
                            <p className="text-sm text-green-600 font-bold pt-5">phase 1</p>
                            <h3 className="text-md font-bold mb-2 mt-1">
                                LMP Faculty Development Program
                            </h3>
                            <p className="font-bold text-xs mt-2 text-gray-600">
                                Facilitator: MIJSC IIMB
                            </p>
                            <p className=" text-xs mt-4 text-gray-600">
                                Duration: 24 Weeks
                            </p>
                            <p className=" text-xs mt-1 text-gray-600">
                                The LMP course, under the Faculty Development Program, includes self learning through MOOCs (Massive Open Online Courses) platform and regular online Module Director interventions by industry experts.
                            </p>

                            <div className="flex items-center my-3 gap-3 mb-4">
                                <p className="text-green-600 font-bold">Continue Reading</p>
                                <FaArrowRight className="mt-1 text-green-600" />
                            </div>
                        </div>
                    </div>
                </Link>



                <Link to='/skill-development'>
                    <div className='py-5'>
                        <div className="rounded-t-xl md:w-[23rem] relative  h-[180px] bg-cover bg-center transition-all duration-700 " style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/lmp-student-skill-development-program.jpg)`, backgroundSize: 'inherit' }}>

                            <div className="hidden md:flex absolute top-3 left-3 z-20">
                                <div className="gap-3 w-fit h-fit rounded-xl shadow-2xl  flex items-center justify-center ">
                                    <HiOutlineBookOpen className="text-white bg-transparent] border w-fit h-[40px] p-1 rounded-md " />
                                </div>
                            </div>
                        </div>
                        <div className='shadow-xl md:w-[23rem] h-fit pb-5 rounded-b-lg px-4 text-left'>
                            <p className='text-sm text-green-600 font-bold pt-5'> phase 2</p>
                            <h3 className='text-md font-bold mb-2 mt-1'>LMP Student Skill Development Program</h3>
                            <p className='font-bold text-xs mt-2 text-gray-600'>Facilitator: Engineering College</p>
                            <p className='text-xs mt-4 text-gray-600'> Duration: 2 semesters </p>
                            <p className='text-xs mt-1 text-gray-600'>The LMP course content for students is planned to be delivered through MOOCs and combined with College Faculty interventions at regular intervals over a period of 2 semesters followed by Projects & internships.</p>
                            <div className='flex  items-center my-3 gap-3 mb-4' >
                                <p className='text-green-600 font-bold '>Continue Reading </p>
                                <FaArrowRight className='mt-1 text-green-600' />
                            </div>
                        </div>
                    </div>
                </Link>
                <Link to='/consultancy-program' >
                    <div className='py-5'>
                        <div className="rounded-t-xl md:w-[23rem] relative  h-[180px] bg-cover bg-center transition-all duration-700" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/lmp-consultancy-program.jpg)` }}>
                            <div className="hidden md:flex absolute top-3 left-3 z-20">
                                <div className="gap-3 w-fit h-fit rounded-xl shadow-2xl  flex items-center justify-center">
                                    <HiOutlineBookOpen className="text-white bg-transparent border w-fit h-[40px] p-1 rounded-md" />
                                </div>
                            </div>
                        </div>
                        <div className='shadow-xl md:w-[23rem] h-fit pb-5 rounded-b-lg px-4 text-left'>
                            <p className='text-sm text-green-600 font-bold pt-5'> phase 3</p>
                            <h3 className='text-md font-bold mb-2 mt-1'>LMP Consultancy Program</h3>
                            <p className='font-bold text-xs mt-2 text-gray-600'>Facilitator: IIM Faculty </p>
                            <p className='text-xs mt-4 text-gray-600'> Duration: 6 Months </p>
                            <p className='text-xs mt-1 text-gray-600'>The Consultancy program for Engineering College Faculty aims to create a team of Lean Consultants who will provide support to help address industry challenges, especially at SMEs.</p>
                            <div className='flex  items-center my-3 gap-3 mb-4' >
                                <p className='text-green-600 font-bold '>Continue Reading </p>
                                <FaArrowRight className='mt-1 text-green-600' />
                            </div>
                        </div>
                    </div>
                </Link>
            </div>

            <Link to='/mijsc-programs'> <div className='flex justify-center items-center gap-3 mb-4 pt-6' >
                <p className='text-green-600 font-bold'>View More Programs </p>
                <FaArrowRight className='mt-1 text-green-600' />
            </div> </Link>


        </section>
    )
}

export default programCard
